import React from "react";
export function Th({ className = "", children }) {
    return <th className={"relative px-2 py-2 text-left align-middle " + className}>{children}</th>;
}
//# sourceMappingURL=th.jsx.map